// Port of api/fuel/app/classes/model/platform/subdomain.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'platform_subdomain',
	prefix: 'subdomain',
	key: 'subdomain_id',
	fields: {
		subdomain_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		subdomain_date: Model.SCHEMA_DATE_CREATE,
		subdomain_status: Model.SCHEMA_NUMBER,
		subdomain_type: Model.SCHEMA_NUMBER,
		subdomain_recipient: Model.SCHEMA_NUMBER,
		subdomain_value: Model.SCHEMA_TEXT
	}
})
